import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'

const driverName = upperFirst(process.env.VUE_APP_LOG_DRIVER)
const log = require(`services/log/${driverName}Log.js`).default

export const bootstrap = async () => {
  Vue.use({
    install (Vue) {
      Vue.prototype.$log = log
    }
  })
}

export default log
